import React from 'react';
import { LandingHeader } from './LandingHeader';
import { LandingHero } from './LandingHero';
import { LandingFeatures } from './LandingFeatures';

export const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#09090B] text-[#FAFAFA] flex flex-col justify-between selection:bg-indigo-600 selection:text-white">
      <LandingHeader />
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-2xl w-full text-center space-y-8">
          <LandingHero />
          <LandingFeatures />
        </div>
      </main>
      <footer className="border-t border-zinc-800/80 py-4 px-6 text-center text-xs text-zinc-500 font-medium">
        © {new Date().getFullYear()} Conversora Inc. • Official Partner Program
      </footer>
    </div>
  );
};

export default LandingPage;
